import { render, staticRenderFns } from "./MaskEditor.vue?vue&type=template&id=1dce962c&scoped=true"
import script from "./MaskEditor.vue?vue&type=script&lang=js"
export * from "./MaskEditor.vue?vue&type=script&lang=js"
import style0 from "./MaskEditor.vue?vue&type=style&index=0&id=1dce962c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dce962c",
  null
  
)

export default component.exports